import React from "react"
import { Grid, Box, Button, Divider, Image, Text } from "theme-ui"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Breadcrumbs from "../../components/Breadcrumbs"
import MdToReact from "../../components/MdToReact"
import RelatedProducts from "./RelatedProducts"
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

const OddSection = ({ image, text }) => {
  return (
    <Grid variant="base" columns={[1, 2]} gap={[4, 6, 8]} sx={{ alignItems: "center", my: [7, 8], bg: "grayXLight", overflowX: "visible" }}>
      <Image src={image} sx={{ mt: [6, -8], mb: [0, -8], maxWidth: [400, "100%"], maxHeight: 600, mx: "auto" }} />

      <Box sx={{ py: [5, 6] }}>
        <MdToReact content={text} />
      </Box>
    </Grid>
  )
}

const EvenSection = ({ image, text }) => {
  return (
    <Grid variant="base" columns={[1, 2]} gap={[4, 6, 8]} sx={{ alignItems: "center", my: [7, 8] }}>
      <Box sx={{ py: [5, 6] }}>
        <MdToReact content={text} />
      </Box>
      
      <Image src={image} alt="Windgeist" sx={{ mt: [-6, 0], mb: [0, 0], maxWidth: [400, "100%"], maxHeight: 600, mx: "auto" }} />
    </Grid>
  )
}

export default function ProductInfo({
    name, 
    status, 
    title, 
    description,
    descriptionPt2, 
    descriptionPt3, 
    additional1Text,
    additional1Image,
    additional2Text,
    additional2Image,
    additional3Text,
    additional3Image,
    additional4Text,
    additional4Image,
    additional5Text,
    additional5Image,
    images, 
    buyButton, 
    extra, 
    relatedProducts 
  }) {
  return (
    <Layout noButton>
      <SEO title={name} />

      <Breadcrumbs title={name} headline={title} parent={["Store", "/store"]} />

      <Grid variant="base" gap={[4, 4, 6, 8]} columns={[1, 1, "1fr 2fr", "2fr 3fr"]} sx={{ alignItems: "start", mt: 4 }}>
        <Box>
          {status === "Available" && buyButton }
          {status === "Sold out" && <Button disabled variant="primaryDisabled" sx={{ width: "100%", mb: 3 }}>Sold out</Button> }
          {status === "Coming soon" && <Button disabled variant="primaryDisabled" sx={{ width: "100%", mb: 3 }}>Coming Soon</Button> }

          <Box sx={{ mt: 4 }}>
            <MdToReact content={description} />
          </Box>
        </Box>
          
        <Box sx={{ bg: "black", border: "1px solid", borderColor: "grayLight" }}>
          <Carousel showStatus={false} showThumbs={false}>
            {/* Carousel from here: https://www.npmjs.com/package/react-responsive-carousel */}
            {images}
          </Carousel>
        </Box>
      </Grid>
      
      {descriptionPt2 && 
        <>
          <Grid variant="base">
            <Divider />
          </Grid>

          <Grid variant="base" gap={[4, 4, 6, 8]} columns={[1, 1, 2, 2]} sx={{ alignItems: "start", overflow: "visible" }}>
            <Box>
              <MdToReact content={descriptionPt2} />
            </Box>

            <Box>
              <MdToReact content={descriptionPt3} />
            </Box>
          </Grid>
        </>
      }
      
      {(additional1Image && additional1Text) && 
        <OddSection text={additional1Text} image={additional1Image} />
      }

      {(additional2Image && additional2Text) && 
        <EvenSection text={additional2Text} image={additional2Image} />
      }

      {(additional3Image && additional3Text) && 
        <OddSection text={additional3Text} image={additional3Image} />
      }

      {(additional4Image && additional4Text) && 
        <EvenSection text={additional4Text} image={additional4Image} />
      }

      {(additional5Image && additional5Text) && 
        <OddSection text={additional5Text} image={additional5Image} />
      }

      {extra &&
        <>
          <Grid variant="base">
            <Divider />
          </Grid> 
        
          {extra}
        </>
      }

      <RelatedProducts products={relatedProducts} />
    </Layout>
  )
}
